module.exports = __webpack_public_path__ + "static/media/matthew.046e91f7.png";